import { useState, useEffect } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import request from "../../../utilities/requests";

const OrgSelect = ({ org, setOrg }) => {
    
  const [orgs, setOrgs] = useState([]);

  useEffect(() => {
    getOrgs();
  }, []);



  const getOrgs = async () => {
    const result = await request("orgs");
    if (result.success) {
      if (result.orgs) {
        setOrgs(result.orgs);
      }
    }
  };


  return (
    <FormControl fullWidth>
      <InputLabel>Org</InputLabel>
      <Select
        value={org ?? "all"}
        label="Org"
        autoWidth
        size="small"
        onChange={(e) => setOrg(e.target.value)}
      >
        <MenuItem value="all">All</MenuItem>
        {orgs.map((org) => {
          return (
            <MenuItem key={org._id} value={org._id}>
              {org.name}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default OrgSelect;
